var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b, _c, _d;
import theme from '../../../../landing/components/core/themes/theme';
// eslint-disable-next-line no-shadow
export var SkillStatus;
(function (SkillStatus) {
    SkillStatus["Mastered"] = "mastered";
    SkillStatus["Developing"] = "developing";
    SkillStatus["HelpNeeded"] = "help_needed";
    SkillStatus["NoData"] = "no_data";
})(SkillStatus || (SkillStatus = {}));
export var ColorByStatus = (_a = {},
    _a[SkillStatus.Mastered] = '#64BB8C',
    _a[SkillStatus.Developing] = '#F5CB50',
    _a[SkillStatus.HelpNeeded] = '#FA7A8D',
    _a[SkillStatus.NoData] = theme.colors.black90,
    _a);
export var ChartColorByStatus = __assign(__assign({}, ColorByStatus), (_b = {}, _b[SkillStatus.NoData] = theme.colors.black95, _b));
export var PROGRESS_STATUS = 'skill_in_progress';
export var SUMMARY_LEGEND_STATUSES = [
    SkillStatus.NoData,
    SkillStatus.HelpNeeded,
    SkillStatus.Developing,
    SkillStatus.Mastered,
];
export var TABLE_LEGEND_STATUSES = __spreadArray(__spreadArray([], SUMMARY_LEGEND_STATUSES, true), [
    PROGRESS_STATUS,
], false);
export var TitleByStatus = (_c = {},
    _c[SkillStatus.Mastered] = 'Mastered',
    _c[SkillStatus.Developing] = 'Developing',
    _c[SkillStatus.HelpNeeded] = 'Help needed',
    _c[SkillStatus.NoData] = 'TBD',
    _c[PROGRESS_STATUS] = 'Skill in progress',
    _c);
export var DescriptionByStatus = (_d = {},
    _d[SkillStatus.Mastered] = 'solves abstract tasks and demonstates >80% accuracy',
    _d[SkillStatus.Developing] = 'solves tasks only with visual models and/or 60-79% accuracy',
    _d[SkillStatus.HelpNeeded] = 'accuracy is <60%',
    _d[SkillStatus.NoData] = 'not enough data to assess this skill',
    _d[PROGRESS_STATUS] = 'the skill that the student is currently working on',
    _d);
